const subUsersHR = {
    "view": {
        "table": {
            "title": "Vaša lista podkorisnika",
            "column": {
                "username": "Korisničko ime",
                "email": "Email",
                "first_name": "Ime",
                "last_name": "Prezime",
                "company": "Tvrtka",
                "sub_user_deal": "Ugovor (%)",
                "contract_expiry": "Isticanje ugovora",
                "is_active": "Aktivan",
                "action": "Akcija"
            },
            "button": {
                "edit": "Uredi",
                "export_csv": "Izvoz CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "label": {
                "yes": "Da",
                "no": "Ne"
            },
            "dropdown": {
                "action": "Akcija",
                "edit": "Uredi",
                "activate": "Aktiviraj",
                "deactivate": "Deaktiviraj"
            }
        },
        "message": {
            "successUpdated": "Račun podkorisnika je ažuriran!",
            "successActivated": "Račun podkorisnika je aktiviran!",
            "successDeactivated": "Račun podkorisnika je deaktiviran!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!",
            "premiumUsersOnly": "Ova značajka je dostupna samo Premium korisnicima. Molimo kontaktirajte podršku ako želite nadograditi svoj račun.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte podršku za više informacija."
        },
        "modal": {
            "activateSubuser": {
                "header": "Aktiviraj podkorisnika",
                "body": "Jeste li sigurni da želite aktivirati podkorisnika {{username}}?"
            },
            "deactivateSubuser": {
                "header": "Deaktiviraj podkorisnika",
                "body": "Jeste li sigurni da želite deaktivirati podkorisnika {{username}}?"
            },
            "button": {
                "cancel": "Odustani",
                "edit": "Uredi",
                "activate": "Aktiviraj",
                "deactivate": "Deaktiviraj"
            }
        }
    },
    "add": {
        "title": "Dodaj podkorisnika",
        "form": {
            "label": {
                "personalDetails": "Osobni podaci",
                "firstName": "Ime",
                "lastName": "Prezime",
                "email": "Email",
                "username": "Korisničko ime",
                "password": "Lozinka",
                "confirmPassword": "Potvrdi lozinku",
                "businessDetails": "Poslovni podaci",
                "companyName": "Naziv tvrtke",
                "contractExpiry": "Isticanje ugovora",
                "subUserDeal": "Ugovor podkorisnika (%)",
                "nationalTaxNumber": "Nacionalni porezni broj",
                "businessRegistrationNumber": "Broj poslovne registracije",
                "contactDetails": "Kontakt podaci",
                "streetAndNumber": "Ulica i kućni broj",
                "postalCode": "Poštanski broj",
                "city": "Grad",
                "country": "Država",
                "phoneNumber": "Telefonski broj"
            },
            "help_text": {
                "contractExpiry": "Napomena: Datum isteka ugovora ne može biti postavljen ranije od {{afterOneYear}}."
            },
            "button": {
                "submit": "Pošalji"
            }
        },
        "message": {
            "success": "Podkorisnik je dodan!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!"
        },
        "modal": {
            "header": "Dodaj podkorisnika",
            "body": "Jeste li sigurni da želite stvoriti novog podkorisnika?"
        }
    },
    "update": {
        "title": "Uredi podkorisnika",
        "form": {
            "label": {
                "personalDetails": "Osobni podaci",
                "firstName": "Ime",
                "lastName": "Prezime",
                "email": "Email",
                "username": "Korisničko ime",
                "password": "Lozinka",
                "confirmPassword": "Potvrdi lozinku",
                "businessDetails": "Poslovni podaci",
                "companyName": "Naziv tvrtke",
                "contractExpiry": "Isticanje ugovora",
                "subUserDeal": "Ugovor podkorisnika (%)",
                "nationalTaxNumber": "Nacionalni porezni broj",
                "businessRegistrationNumber": "Broj poslovne registracije",
                "contactDetails": "Kontakt podaci",
                "streetAndNumber": "Ulica i kućni broj",
                "postalCode": "Poštanski broj",
                "city": "Grad",
                "country": "Država",
                "phoneNumber": "Telefonski broj"
            },
            "help_text": {
                "contractExpiry": "Napomena: Datum isteka ugovora ne može biti postavljen ranije od {{afterOneYear}}."
            },
            "button": {
                "submit": "Pošalji"
            }
        },
        "message": {
            "success": "Podkorisnik je ažuriran!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovo!"
        }
    }
};

export default subUsersHR;